import { assessmentSummaryConstants } from "../../_constants";
import { assessmentSummaryService } from "../../_services";

export const getAssessmentReportAction = {
  getAssessmentReportHandler,
};

function getAssessmentReportHandler(id) {
  return (dispatch) => {
    dispatch(request());
    assessmentSummaryService.getAssessmentReportHandler(id).then(
      (getAssessementReport) => {
        dispatch(success(getAssessementReport));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: assessmentSummaryConstants.REQUEST_ASSESSMENT_REPORT };
  }
  function success(getAssessementReport) {
    return {
      type: assessmentSummaryConstants.RECEIVE_ASSESSMENT_REPORT,
      getAssessementReport,
    };
  }
  function failure(error) {
    return { type: assessmentSummaryConstants.ASSESSMENT_REPORT_ERROR, error };
  }
}



// WEBPACK FOOTER //
// ./src/_actions/AssessmentSummary/getAssessmentReport.action.js